import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMention = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M7.75 2.584a7.75 7.75 0 0 1 10 7.416v1.166a2.694 2.694 0 0 1-4.943 1.485 3.861 3.861 0 1 1-.222-5.52.75.75 0 0 1 1.276.535v3.5a1.194 1.194 0 1 0 2.389 0V10a6.25 6.25 0 1 0-4.632 6.037.75.75 0 0 1 .388 1.449A7.75 7.75 0 0 1 7.75 2.584m4.611 7.4a2.361 2.361 0 1 0 0 .032z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMention;
